import axios from 'axios';
import Api from '../library/Api.js';
import base from './ServicoBase.js';

export default {

        getModel() {


                var form = {
                        id: null,
                        nome: "",
                        data_cadastro: null,
                        perfil: 1,
                        login: "",
                        obs: "",
                        id_profissional: null,
                        id_cliente: null,
                        todas_unidades: null,
                        unidades: "",
                        checklists: "",
                        todas_checklists: null,
                        email: ""


                }

                return form;
        },

        getById(id) {

                return Api.Call("usuarios/" + id, "get", {});

        },

        salvar(form) {


                if (form.id != null && form.id != "") {
                        // var data = base.removeColumns( form, "cadastrado_por,valido,verificado,eliminado");
                        return Api.Call("usuarios/" + form.id, "PUT", form);
                } else {


                        return Api.Call("usuarios", "POST", form);


                }

        },
        get_parametros(id) {
                return Api.Call("usuarios_parameters/" + id, "get", {});
        },
        save_parametros(id, data) {
                return Api.Call("usuarios_parameters/" + id, "post", data);
        },
        filtrar(page, search) {

                var data = { filtro: search, page: page, pagesize: process.env.VUE_APP_PAGESIZE }

                return Api.Call("usuarios_grid", "get", data);


        },
        delete(id) {
                return Api.Call("usuarios/" + id, "DELETE", {});
        },
        getPageSize() {

                if (window.user_qtde_paginas != null && window.user_qtde_paginas != undefined) {
                        return parseInt(window.user_qtde_paginas);
                }


                var res = window.sessionStorage.getItem("socv2_user");


                var objUser = JSON.parse(res);
                console.log("socv2_user? ", objUser);
                if (objUser.parametros != null && objUser.parametros.qtde_paginas != null && objUser.parametros.qtde_paginas != undefined) {
                        window.user_qtde_paginas = objUser.parametros.qtde_paginas;
                        return parseInt(objUser.parametros.qtde_paginas);
                }

                window.user_qtde_paginas = 6;
                return 6;
        },

        getList(filtro, order, order_type) {

                var data = { filtro: filtro, order: order, order_type: order_type }

                return Api.Call("usuarios?" + base.serialize(data), "get", data);


        },
        getList2(data, order, order_type) {

                data["order"] = order;
                data["order_type"] = order_type;

                return Api.Call("usuarios?" + base.serialize(data), "get", data);


        }
}
